const addPerformanceTiming = (event: string) => {
  if (IS_BROWSER && window.performance && window.dataLayer) {
    window.dataLayer.push({
      event,
      [event]: window.performance.now(),
    });
  }
};
export default addPerformanceTiming;
